export const GraphHistogram = ({
  fillColor,
  width = '10rem',
}: {
  fillColor: string;
  width?: string;
}) => (
  <svg width={width} viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'>
    {/* Axes */}
    <line x1='0' y1='0' x2='0' y2='20' stroke={fillColor} strokeWidth={1} />
    <line x1='0' y1='20' x2='20' y2='20' stroke={fillColor} strokeWidth={1} />
    {/* Chart */}
    <polyline points='3,20 3,10 8,10 8,20' fill='none' stroke={fillColor} strokeWidth={0.5} />
    <polyline points='8,20 8,5 13,5 13,20' fill='none' stroke={fillColor} strokeWidth={0.5} />
    <polyline points='13,20 13,8 18,8 18,20' fill='none' stroke={fillColor} strokeWidth={0.5} />
  </svg>
);
